import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useKitchenStore = create((set, get) => ({
  kitchens: [],
  stationReport: [],
  pagination: null,
  isLoading: false,
  isError: false,
  error: undefined,
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createKitchen: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the kitchen creation request
      const response = await axiosHelper.post("/kitchen/create", body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });


      // Refresh the list of Kitchens
      await get().getKitchens({ page: 1, perPage: 10 });

      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getKitchensBySite: async (siteId, { page, perPage, search = "" }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }
      let response = await axiosHelper.get(
        `/kitchen/site/${siteId}?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        kitchens: response?.kitchens,
        pagination: response?.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },

  getKitchens: async ({ page, perPage, search = "" }) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }
      
      let response = await axiosHelper.get(
        `/kitchen?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        kitchens: response.kitchens,
        pagination: response.pagination,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  getServiceStationStats: async (siteIds, startDate, endDate, timezone = "UTC", kitchenId) => {
    const siteIdsString = siteIds.join(",");

    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      const params = new URLSearchParams();
      if (siteIds.length > 0) params.append("sites", siteIdsString);
      if (startDate) params.append("startDate", startDate.toISOString());
      if (endDate) params.append("endDate", endDate.toISOString());
      if (timezone) params.append("timezone", timezone);
      if (kitchenId) params.append("kitchen_id", kitchenId.toString());

      const response = await axiosHelper.get(
        `/order/reporting/services/orders?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        stationReport: response,
        isLoading: false,
      });

      return response;
    } catch (e) {
      console.error("Failed to fetch service station stats:", e);
    } finally {
      set({ isLoading: false });
    }
  },


  updateKitchen: async (id, info) => {
    try {
      set({ isLoading: true });
      let response = await axiosHelper.patch(`/kitchen/update/${id}`, info);

      await get().getKitchens({ page: 1, perPage: 10 });

      return true;
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  deleteKitchen: async (kitchen_id) => {
    try {
      set({ isLoading: true });
      const accessToken = await tokenHelper.getToken();

      let response = await axiosHelper.delete(`/kitchen/${kitchen_id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      await get().getKitchens({ page: 1, perPage: 10 });
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  getServiceAppSettings: async (kitchenId) => {
    const accessToken = await tokenHelper.getToken();
    const response = await axiosHelper.get(
      `/kitchen/${kitchenId}/service-app-settings`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    return response?.data || response;
  },
  updateServiceAppSettings: async (kitchenId, body) => {
    const accessToken = await tokenHelper.getToken();
    const response = await axiosHelper.patch(
      `/kitchen/${kitchenId}/service-app-settings`,
      body,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    return response?.data || response;
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
}));
